export const RENAME_STATUS_INPUT_TEST_ID = 'rename-status-input'
export const RENAME_STATUS_MODAL_TEST_ID = 'rename-status-modal'
